import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { SharedPipesDateModule } from '@fantaz/shared/pipes/date';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { StampComponent } from './stamp.component';

@NgModule({
  imports: [CommonModule, MaterialModule, SharedPipesDateModule],
  declarations: [StampComponent],
  exports: [StampComponent],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedUiStampModule {}
